export default __webpack_public_path__ + "static/media/aiImage.f3199bab.ico";